import * as yup from "yup";
import {REG_EXS} from "../../../utils/constants";

const ldapHost = () => {
  yup.addMethod(yup.string, "ldapHost", function (message) {
    return this.test("ldapHost", message, value => {
        if (!value) {
          return true;
        }
        return REG_EXS.VALID_HOST.test(value);
      }
    );
  });
};

export default ldapHost;